import { Component, HostListener, ApplicationRef, ViewChildren, QueryList, OnInit, Input, Output, EventEmitter, AfterViewInit, Renderer2, ElementRef, ViewChild, AfterViewChecked } from '@angular/core';
import { DinamicData, Cell } from '../../../models/dinamic-data';
import { MatCheckbox } from '@angular/material/checkbox';
import { ChangeDetectorRef, NgZone } from '@angular/core';
import { UserService } from "../../../services/user.service";
import {POService} from "../../../services/po.service";
import { Methods } from "../../methods";
declare var $: any;

declare interface option {
  colName: string,
  position: number,
  visibility: boolean,
  origin: number
}

declare interface filtro {
  key: string,
  title: string,
  value: string,
  type: string
}

@Component({
  selector: 'dinamic-table',
  templateUrl: './dinamic-table.component.html',
  styleUrls: ['./dinamic-table.component.css'],
  providers : [UserService,POService]
})
export class DinamicTableComponent implements OnInit, AfterViewInit, AfterViewChecked {
  public showTable = true;
  @Input() id: string = 'datatable';
  @Input() data: DinamicData;
  @Input() config: Array<option> = [];
  @Input() dateColums: Array<number> = [];
  @Input() sort: Array<any> = [];
  @Input() columnfilters: Array<filtro> = [];
  @Input() frontpaginate = false;
  @Input() bsort = false;
  @Input() newbutton = false;
  @Input() cleanbulk = false;
  @Input() sortColumn = null;
  @Input() sortOrder = 'desc';
  @Input() checkAllGrayed = false;
  @Input() dbname = '';
  @Input() type = false;
  @Input() disableAllCheckBox: boolean = false;

  @Input() campoBusqueda = '';
  @Input() perPage = '10';
  @Input() page = 1;
  @Input() total_items_count = 0;
  @Input() total_pages = 1

  @Input() enableDrop: boolean = false;
  @Output() idfolderdrop: EventEmitter<any>;

  @Input() btnExcel = true;
  @Input() btnExcelComplete = true;
  @Input() btnPDF = true;
  @Input() btnPrint = true;
  @Input() btnCol = true;
  @Input() btnOrd = true;
  @Input() search = false;
 /*  @Input() ColRe = false; */
  @Input() personalButtons: Array<any> = [];
  @Input() bulk: Array<any> = [];

  @Output() buscar: EventEmitter<any>;
  @Output() action_button: EventEmitter<any>;
  @Output() newConfig: EventEmitter<any>;
  @Output() changeBulk: EventEmitter<any>;
  @Output() changeBulkTrigger: EventEmitter<any>;
  @Output() resetTrigger: EventEmitter<any>;
  @Output() bulkListChange = new EventEmitter<string[]>();  // O el tipo correcto de tus ids

  @Output() seleccionado: EventEmitter<any>;
/* button report */
@Input() buttonName: string | null = null;
@Input() buttonClass: string | null = null;
@Input() buttonAction!: () => void;
@Output() buttonClicked = new EventEmitter<void>(); 
@Input() buttonName2: string | null = null;
@Input() buttonClass2: string | null = null;
@Input() buttonAction2!: () => void;
@Output() buttonClicked2 = new EventEmitter<void>(); 

@Output() rightClickAction = new EventEmitter<any>(); 
@Output() toggleButtons: EventEmitter<boolean> = new EventEmitter();
@Output() actionClicked = new EventEmitter<any>();
@Input() actionColumnWidth: string = 'auto';
@Input() smallcell = false;
/* end button report */
  @Input()
    set resetBulkTrigger(value: boolean) {
        if (value) {
            this.bulk = [];
            // Aquí puedes agregar cualquier lógica adicional que necesites ejecutar al vaciar bulk
            this.onBulkReset();
        }
    }

  public esbusqueda: boolean;
  public showingNav: number = 0;
  public showingTo: number = 0;
  public pages = [];
  public filterValues = [];
  public mtds: Methods = new Methods();
  public testCheck =false;

  public selectrow = null;
  public ocultar:boolean = false;
  public token;

  public colReorderActivated: boolean = false;
  public loadingRefresh: boolean = false;
 

  public json_data_table = null;
  // Track the current focus
  currentFocus: number = 0;

  public isArrowKeyMovement = false;



  @ViewChildren('rowElement') rows: QueryList<ElementRef>;


   @ViewChildren('checkboxes') checkboxes: QueryList<MatCheckbox>;
   @ViewChild('childScrollElement') childScrollElement: ElementRef;

   
  constructor(private appRef: ApplicationRef, private renderer: Renderer2, private el: ElementRef, private changeDetectorRef: ChangeDetectorRef,private ngZone: NgZone, private _userService: UserService) {
    this.buscar = new EventEmitter;
    this.action_button = new EventEmitter;
    this.newConfig = new EventEmitter;
    this.changeBulk = new EventEmitter;
    this.changeBulkTrigger = new EventEmitter;
    this.resetTrigger = new EventEmitter;
    this.seleccionado = new EventEmitter;
    this.idfolderdrop = new EventEmitter;
    this.token = JSON.parse(localStorage.getItem("token"));
    
  }

  // Detecta el evento de resize del navegador
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.resetTable();
  }

  // Oculta y vuelve a mostrar la tabla para reinicializarla
  resetTable() {
   this.resetTrigger.emit({ value: true });
   

  }
  handleButtonClick() {
    if (this.buttonAction) {
      this.buttonAction(); // Ejecuta la función pasada
    }
    this.buttonClicked.emit(); // Opcional: notifica al padre
  }
  handleButtonClick2() {
    if (this.buttonAction2) {
      this.buttonAction2(); // Ejecuta la función pasada
    }
    this.buttonClicked2.emit(); // Opcional: notifica al padre
  }
  private onBulkReset(): void {
    this.selectAll();
    // Lógica que se ejecutará cuando bulk se vacíe
    //console.log('Bulk ha sido vaciado');
    this.changeBulkTrigger.emit({ value: this.bulk });
    
}

  ngAfterViewChecked() {

    if (this.isArrowKeyMovement) {
      this.setFocusOnCurrentRow();
    }
  }

/*   reinitializeCustomTooltips(): void {
    const tooltipElements = this.el.nativeElement.querySelectorAll('.tooltip-container');
  
    tooltipElements.forEach((element: HTMLElement) => {
      element.addEventListener('mouseenter', () => {
        const tooltip = document.createElement('div');
        tooltip.className = 'custom-tooltip';
        tooltip.textContent = element.getAttribute('data-tooltip');
        document.body.appendChild(tooltip);
  
        const rect = element.getBoundingClientRect();
        tooltip.style.position = 'absolute';
        tooltip.style.top = `${rect.top + window.scrollY - tooltip.offsetHeight - 10}px`;
        tooltip.style.left = `${rect.left + window.scrollX + rect.width / 2 - tooltip.offsetWidth / 2}px`;
        tooltip.style.zIndex = '1000';
      });
  
      element.addEventListener('mouseleave', () => {
        const tooltip = document.querySelector('.custom-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    });
  } */
  reinitializeCustomTooltips(): void {
    const tooltipElements = this.el.nativeElement.querySelectorAll('.tooltip-container');
  
    tooltipElements.forEach((element: HTMLElement) => {
      element.addEventListener('mouseenter', () => {
        const isTruncated = element.offsetWidth < element.scrollWidth;
        if (!isTruncated) {
          return;
        }
  
        const tooltip = document.createElement('div');
        tooltip.className = 'custom-tooltip';
        tooltip.textContent = element.getAttribute('data-tooltip') || '';
        document.body.appendChild(tooltip);
  
        const rect = element.getBoundingClientRect();
        tooltip.style.position = 'absolute';
        tooltip.style.top = `${rect.top + window.scrollY - tooltip.offsetHeight - 10}px`;
        tooltip.style.left = `${rect.left + window.scrollX + rect.width / 2 - tooltip.offsetWidth / 2}px`;
        tooltip.style.zIndex = '1000';
      });
  
      element.addEventListener('mouseleave', () => {
        const tooltip = document.querySelector('.custom-tooltip');
        if (tooltip) {
          tooltip.remove();
        }
      });
    });
  }
  

  changeTestCheck(){
    this.testCheck = !this.testCheck;



  }

  stopPropagation(event: WheelEvent): void {
    // Prevent the scroll event from bubbling up to the parent element
    event.stopPropagation();

    //console.log(event);

    // Perform any other scrolling logic you need here
    // For example, you can manually adjust the child's scrollTop property.
    this.childScrollElement.nativeElement.scrollTop += event.deltaY;
  }



  ngOnInit() {
    //console.log("this.data => ", this.data);
    //console.log("this.config => ", this.config);
     let show_d_tables:any = localStorage.getItem('show_d_tables');
     let me = this;

   //  console.log("data.headers => ", this.data.headers);
   // console.log("data.rows => ", this.data.rows);
   
       /*
       Se comenta funcion, mejor hacer desde backend
        if (show_d_tables !== null) {
           console.log("show_d_tables adentro => ", show_d_tables);
            this.perPage = show_d_tables.toString();
        }*/
   
    this.esbusqueda = (this.campoBusqueda !== '');

    for (let filter of this.columnfilters) {
      if (filter && filter.value) {
        this.esbusqueda = true;
        break;
      }
    }

    

   

    this.total_items_count = this.total_items_count;
    this.total_pages = this.total_pages;

    this.showingTo = this.page * Number(this.perPage);
    this.showingNav = (this.page * Number(this.perPage)) - (Number(this.perPage) - 1);

    let valorfor = this.page - 2;
    if  (valorfor < 0) { valorfor = 0; }
    this.pages = [];
    let cont = 0;
    for (let i = valorfor; i < this.total_pages; i++) {
      let vaalortest = this.page - i;
        // console.log(vaalortest);
      this.pages.push(i);
      cont++;
      if (cont > 5) { break; }
    }
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
}

onDrop(event: DragEvent) {
    event.preventDefault();
     let targetElement: any = event.target;

    // Traverse up to find the <tr> element with the 'data-id' attribute
    while (targetElement && targetElement.nodeName !== 'TR') {
        targetElement = targetElement.parentElement;
    }

    // If we found a <tr> element, retrieve its 'data-id' attribute
    if (targetElement && targetElement.hasAttribute('data-id')) {
        const dataId = targetElement.getAttribute('data-id');
        //console.log("Element dropped with data-id: ", dataId);
        this.idfolderdrop.emit({ idfolder: dataId });
    } else {
        //console.log("Element dropped, but couldn't find a data-id attribute");
    }
  
}


  unclick(i, row) {
    this.selectrow = i;
    // Update the currentFocus
  this.currentFocus = i;
   this.updateFocusVisuals();
    
    if(this.id === 'inventoryTable' || this.id === 'historyTable')
      this.saveEmit('Attribute', row[0].value);

  }

  updateFocusVisuals() {
  // Remove focus from all rows
  this.rows.forEach((row, index) => {
    row.nativeElement.classList.remove('bg-lumin');
  });

  // Add focus to the current row
  if (this.rows && this.rows.toArray()[this.currentFocus]) {
    this.rows.toArray()[this.currentFocus].nativeElement.classList.add('bg-lumin');
  }
}

  dosclicks(row) {
    //console.log('dobleclick')
    const filter = row.filter( cell =>{ if(cell.type === "actions") { 
      return cell.value } });
    // console.log(filter);
    const actions = filter ?  filter[0].value : null;
    if (actions) {
      for (let action of actions) {
        const act = action.action.toLowerCase();
        if ( act === 'show' || act === 'detail' || act === 'ver' || act === 'showdetail') {
          this.saveEmit(action.action, (action.value || row[0].value));
        }
      }
    } else {
      this.saveEmit('doubleclick', row);
    }

  }

  rightClick(event: MouseEvent, row: any) {
    // Evita el menú contextual del navegador
    event.preventDefault();
    const optionalValue = row[3]?.value || null;
    if(this.id === 'inventoryTable' || this.id === 'historyTable' || this.id === 'pricehistoryTable'){

      this.saveEmit('showLogs', row[0].value, optionalValue);
    }else{
      this.saveEmit('showLogs', row[0].value);
    }
}

  ordenar(column) {

    if (column === this.sortColumn && this.sortOrder === 'desc') {
      this.sortOrder = 'asc';
    } else {
      this.sortOrder = 'desc';
      this.sortColumn = column;
    }
    this.goToPage(1);
  }

  saveEmit(act, id,optionalValue?: any) {
    this.action_button.emit(
      {
        action: act,
        id: id,
        optionalValue: optionalValue
      }
    );
  }

  restoreTable() {
    this.page = 1;
    this.campoBusqueda = '';
    this.perPage = '10';

    for (let filter of this.columnfilters) {
      if (filter) {
        filter.value = ''
      }
    }
    this.goToPage(1);
  }

  goToPage(page) {

    localStorage.setItem('show_d_tables', this.perPage);

    this.page = page;
    this.buscar.emit({search: this.campoBusqueda, page: this.page, perPage: this.perPage, order: this.sortOrder, sortby: this.sortColumn});
  }

 
  public tableSorted: boolean = false;
  public tableSorted_real: boolean = false;
  clickBox(checkbox){
    console.log("clickBox", checkbox);
    console.log("this.tableSorted => ", this.tableSorted);
    if(!this.tableSorted && this.tableSorted_real == false )
      return false;

   
  

   // console.log("checkbox => ", checkbox);
    const dataAttribute = checkbox.getAttribute('data-attr');

    let dataSelected = checkbox.getAttribute('data-selected');
    //console.log("checkbox.getAttribute('data-selected') => ", checkbox.getAttribute('data-selected'));
  
    //console.log("dataSelected => ", dataSelected);
    let newDataSelected = dataSelected === "true" ? "false" : "true";
    //newDataSelected = dataSelected === "false" ? "true" : "false";

    //console.log("newDataSelected => ", newDataSelected);
        
        checkbox.setAttribute('data-selected', newDataSelected);

   // if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-check-square")){
    if(newDataSelected == 'false'){
      //console.log("has fa-check-square");
      
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-check-square");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-square-o");
   //  } else if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-square-o")){
 } else if(newDataSelected == 'true'){
        // console.log("has fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-check-square");
     }

   
    let value = dataAttribute.toString();

    if(newDataSelected == 'false'){
      for ( let i = 0; i < this.bulk.length; i++) {
        if (this.bulk[i] === value) {
          this.bulk.splice(i,1); 

          this.changeBulk.emit({ check: false, value });
          this.bulkListChange.emit(this.bulk);
          return;
        }
      }
    } else {
      this.bulk.push(value);
      this.changeBulk.emit({ check: true, value });
      this.bulkListChange.emit(this.bulk);
    }

     

  }

  initializeTable(){

    let me = this;
    

    if (this.btnExcelComplete && this.type === true) {
      this.personalButtons.push({
        extend: 'excel',
        text: '<span class="gts-btn-icon">download</span>',
        titleAttr: 'Download inventory',
        className: 'gts-btn-primary-outline-actions-start',
        exportOptions: {
          columns: ':visible',
        },
        action: (e, dt, node, config) => {
          this.actionClicked.emit();
        },
      });
    }
    

     if (this.btnExcel) {
      this.personalButtons.push(
        {
          extend: 'excel',
          text: '<span class="gts-btn-icon">table_view</span>',
          titleAttr: 'Excel',
          className: 'gts-btn-primary-outline-actions-start',
          exportOptions: {
            columns: ':visible'
          }
        }
      )
    }

    if (this.btnPDF) {
      this.personalButtons.push(
        {
          extend: 'pdf',
          text: '<span class="gts-btn-icon">picture_as_pdf</span>',
          titleAttr: 'PDF',
          className: 'gts-btn-primary-outline-actions',
          exportOptions: {
            columns: ':visible'
          }
        }
      )
    }

    if (this.btnPrint) {
      this.personalButtons.push(
        {
          extend: 'print',
          text: '<span class="gts-btn-icon">print</span>',
          titleAttr: 'print',
          className: 'gts-btn-primary-outline-actions',
          exportOptions: {
            columns: ':visible'
          }
        }
      )
    }
  

    if(this.btnOrd){
      this.personalButtons.push(

        {
      
          text: me.colReorderActivated ? '<span class="gts-btn-icon">sync_alt</span>': '<span class="gts-btn-icon">sync_alt</span>',
          titleAttr: 'Enable ColReorder',
          className: me.colReorderActivated ? 'gts-btn-primary-outline-actions btnorder' : 'gts-btn-primary-outline-actions btnorder',
          exportOptions: {
            columns: ':visible'
          },
          action: function ( e, dt, node, config ) {
                    //console.log("e => ", e);
                    //console.log("dt => ", dt);
                    //console.log("node => ", node);
                    //console.log("config => ", config);
                    if(config.titleAttr == "Enable ColReorder"){
                  
                       me.loadingRefresh = true;
                       me.colReorderActivated = !me.colReorderActivated;

                     
                       if(me.colReorderActivated)
                        $( "#enableReordering" ).trigger( "click" );
                      else
                        $( "#disableReordering" ).trigger( "click" );


                       //$('#' + me.id).dataTable().fnDestroy();
                       //me.initializeTable();
                    }
                }
        }
      )
    }


    if (this.btnCol) {
      this.personalButtons.push(
        {
          extend: 'colvis',
          text: '<span class="gts-btn-icon">view_column</span>',
          className: 'gts-btn-primary-outline-actions-end button-colvis-custom',
          titleAttr: 'Column visibility'
        }
      )
    }




    let visibility = [];

    if(Array.isArray(this.config)){
        for (let option of this.config) {
        if (!option.visibility) {
          visibility.push(option.origin);
        }
      }
    }
    

    let positions = [];
    if(Array.isArray(this.config)){
      while (positions.length < this.config.length) {
        for (let option of this.config) {
          if (option.position === positions.length) {
            positions.push(option.origin);
            break;
          }
        }
      }
    }
    

    //console.log("this.dateColums => ", this.dateColums);
    //console.log("this.personalButtons => ", this.personalButtons);
    //console.log("this.config => ", this.config);
    //console.log("positions => ", positions);
    let configuraciones = this.frontpaginate ?
    {
      colReorder: {
        order: positions.length ? positions : undefined,
        enable: this.colReorderActivated,
        realtime: true
      },
      columnDefs: [
        { targets: 0, width: '25px' },
        { targets: this.dateColums, type: 'date' },
        { targets: visibility, visible: false }
      ],
      autoWidth: false,
      order: this.sort,
      dom: 'Bflrtip',
      buttons: [
        this.personalButtons
      ],
      'pagingType': 'full_numbers',
      'lengthMenu': [
        [10, 25, 50, 100, 200, 500, 1000, -1],
        [10, 25, 50, 100, 200, 500, 1000, 'All']
      ],
      // responsive: true,
      scrollY: '400px',
      scrollX: true,
      scrollCollapse: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }

    }

    :

    {
      colReorder: {
        order: positions.length ? positions : undefined,
        enable: this.colReorderActivated,
        realtime: true
      },
      columnDefs: [
        { targets: 0, width: '25px' },
        { targets: this.dateColums, type: 'date' },
        { targets: visibility, visible: false }
      ],
      bInfo: false,
      ordering: false,
      searching: false,
      paging: false,
      dom: 'Bflrtip',
      buttons: [
        this.personalButtons
      ],
      // responsive: true,
      autoWidth: false,
      scrollY: '400px',
      scrollX: true,
      scrollCollapse: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }

    };
    //console.log("configuraciones => ", configuraciones);

    this.json_data_table = configuraciones;

    //setTimeout inicia
   // setTimeout(() => {
    let table = $('#' + this.id).DataTable(configuraciones);

    // Asociar eventos de clic a los botones personalizados
    /*$('#custom-table-view').click(function() {
      table.button('.buttons-excel').trigger();
    });*/

    table.columns.adjust().draw();

    //console.log("table.columns => ", table.columns);

    table.on('click', '.emitir', (e) => {
      let res = e.target.id.split("-");
      console.log("res => ", res);
      let value = this.data.rows[res[1]][res[2]].value[res[3]].value || this.data.rows[res[1]][0].value;

      const tooltip = document.querySelector('.custom-tooltip');
      if (tooltip){

        tooltip.remove();
      } 

        
      this.saveEmit(res[0], value);
      
    });

     table.on('click', '.emitirdos', (e) => {
      let res = e.target.id.split("-");
      console.log("res => ", res);
      console.log("this.data.rows => ", this.data.rows);
      let value;
      if(this.data.rows[res[1]] && this.data.rows[res[1]][0])
         value = this.data.rows[res[1]][0].value;             
      this.saveEmit(res[0], value);
      const tooltip = document.querySelector('.custom-tooltip');
      if (tooltip){

        tooltip.remove();
      } 
    });




$('.btnorder').on( 'click', function () {
  //console.log("this.colReorderActivated => ", me.colReorderActivated);
  if(me.colReorderActivated){
    $(this).css({
        //'color': 'white',       // Cambia el color del texto
        //'background-color': 'green',  // Cambia el color de fondo
        'background-color': '#f8e9fe',  // Cambia el color de fondo
        // Aquí puedes añadir más propiedades CSS según necesites
    });
  } else {
    $(this).css({
        //'color': 'black',       // Cambia el color del texto
        'background-color': 'white',  // Cambia el color de fondo
        // Aquí puedes añadir más propiedades CSS según necesites
    });
  }

} );


$('#enableReordering').on( 'click', function () {
    table.colReorder.enable( true );
} );

$('#disableReordering').on( 'click', function () {
    table.colReorder.enable( false );
} );

table.on('order', function () {
    var order = table.order();
    console.log("order => ", order[0][1]);

   if(order[0][1] == 'asc') me.tableSorted = true;
   else me.tableSorted = false;

    /*$('#orderInfo').html(
        'Ordering on column ' + order[0][0] + ' (' + order[0][1] + ')'
    );*/
});

    table.on( 'column-reorder', function ( e, settings, details ) {
     me.tableSorted = true;
     me.tableSorted_real = true;
     me.unSelectAll();
     if (!Array.isArray(me.config)) {
      me.config = me.mtds.colopt(me.data.headers, []);
    }
for (let col of settings.aoColumns) {
        for (let option of me.config) {
          if (option.origin === col._ColReorder_iOrigCol) {
            option.position = col.idx;
            break;
          }
        }
      }



      me.newConfig.emit(me.config);

      me.reinitializeCustomTooltips(); 
    });


 


    table.on( 'column-visibility.dt', function ( e, settings, column, state ) {
     
     /* 
      console.log("e => ", e);
      console.log("settings => ", settings);
      console.log("column => ", column);
      console.log("state => ", state);*/
      if (!Array.isArray(this.config)) {

        this.config = this.mtds.colopt(this.data.headers, []);
      }
      for (let option of this.config) {
        if (option.position === column) {
          option.visibility = state;
          break;
        }
      }
      this.newConfig.emit(this.config);
     /*  me.reinitializeCustomTooltips();  */
    }.bind(this) );

    me.reinitializeCustomTooltips(); 
  
    // Get all elements with the specific classname within this component
    const checkboxes = this.el.nativeElement.querySelectorAll('.checkboxrow');

    


checkboxes.forEach(checkbox => {
  this.renderer.listen(checkbox, 'change', (event) => {
    
    const dataAttribute = checkbox.getAttribute('data-attr');
    //console.log("dataAttribute => ", dataAttribute);
    let value = dataAttribute.toString();

     for ( let i = 0; i < this.bulk.length; i++) {
      if (this.bulk[i] === value) {
        this.bulk.splice(i,1); 

        this.changeBulk.emit({ check: false, value });
        this.bulkListChange.emit(this.bulk);
        return;
      }
    }

    this.bulk.push(value.toString());
    this.changeBulk.emit({ check: true, value });
    this.bulkListChange.emit(this.bulk);
  });

  this.renderer.listen(checkbox, 'click', (event) => {
    console.log("event listener =>", event);

    //this.clickBox(checkbox);
    //el contenido anterior de este listener fue movido a clickbox
    // console.log("checkbox => ", checkbox);
    const dataAttribute = checkbox.getAttribute('data-attr');

    let dataSelected = checkbox.getAttribute('data-selected');
    //console.log("checkbox.getAttribute('data-selected') => ", checkbox.getAttribute('data-selected'));
  
    //console.log("dataSelected => ", dataSelected);
    let newDataSelected = dataSelected === "true" ? "false" : "true";
    //newDataSelected = dataSelected === "false" ? "true" : "false";

    //console.log("newDataSelected => ", newDataSelected);
        
        checkbox.setAttribute('data-selected', newDataSelected);

   // if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-check-square")){
    if(newDataSelected == 'false'){
      //console.log("has fa-check-square");
      
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-check-square");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-square-o");
   //  } else if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-square-o")){
 } else if(newDataSelected == 'true'){
        // console.log("has fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-check-square");
     }

   
    let value = dataAttribute.toString();

    if(newDataSelected == 'false'){
      for ( let i = 0; i < this.bulk.length; i++) {
        if (this.bulk[i] === value) {
          this.bulk.splice(i,1); 

          this.changeBulk.emit({ check: false, value });
          this.bulkListChange.emit(this.bulk);
          return;
        }
      }
    } else {
      this.bulk.push(value);
      this.changeBulk.emit({ check: true, value });
      this.bulkListChange.emit(this.bulk);
    }

  });


});


//}, 0);//setTimeout fin
    
    // Remover el span con la clase "dt-button-down-arrow" del botón "colvis"
    $('.buttons-colvis .dt-button-down-arrow').remove();
    
    this.loadingRefresh = false

  }
  showDtButtons: boolean = false;
  ngAfterViewInit() {

    this.initializeTable();

     this.renderer.listen(this.el.nativeElement, 'click', (event) => {
      if (event.target.matches('.checkboxrow, .checkboxrow *')) {
        this.clickBox(event.target.closest('.checkboxrow'));
      }
    });

    setTimeout(() => {
      const colvisButton = document.querySelector('.buttons-colvis');
      if (colvisButton) {
        colvisButton.addEventListener('click', () => {
          this.showDtButtons = true;
          this.toggleButtons.emit(true); // Emitir evento al padre
          this.changeDetectorRef.detectChanges();
        });
      }
    }, 500);
  
    // 🔍 Observador para detectar cuando el menú de visibilidad de columnas desaparece
    const observer = new MutationObserver(() => {
      const colvisMenu = document.querySelector('.dt-button-collection');
      if (!colvisMenu) {
        this.showDtButtons = false;
        this.toggleButtons.emit(false); // Emitir evento al padre
        this.changeDetectorRef.detectChanges();
      }
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
    /*  */

  }
  ngOnDestroy() {
    const tooltip = document.querySelector('.custom-tooltip');
    if (tooltip) {
      tooltip.remove();
    }
  }
  onFocus(event: FocusEvent){
    // Check if the target of the focus event is inside the datatable
    const isInsideDatatable = this.isElementInsideDatatable(event.target as HTMLElement);

    if (isInsideDatatable) {
      this.isArrowKeyMovement = true;
      // Additional code related to focusing inside the datatable
    }
  }

  // Helper method to check if an element is inside the datatable
  private isElementInsideDatatable(element: HTMLElement): boolean {
    // Replace 'datatable' with the actual selector or class of your datatable
    return element.closest('#id') !== null;
  }

  onBlur(){
     this.isArrowKeyMovement = false;
  }

  onMouseLeave() {
    this.isArrowKeyMovement = false;
  }

   // Angular's way of handling keydown events
  onKeydown(event: KeyboardEvent) {
    //console.log("event.key => ", event.key);
     if (event.key === 'ArrowDown') {
      this.isArrowKeyMovement = true;
      event.stopPropagation();
      this.moveFocus(1);
    } else if (event.key === 'ArrowUp') {
      this.isArrowKeyMovement = true;
      event.stopPropagation();
      this.moveFocus(-1);
    } else if (event.key === 'Enter') {
      // Trigger double click action on the current row
      const currentRowData = this.data.rows[this.currentFocus];
      if (currentRowData) {
        this.dosclicks(currentRowData);
      }
    }
  }

  moveFocus(direction: number) {

    // Remove focus from current row
    if (this.rows && this.rows.toArray()[this.currentFocus]) {
      this.rows.toArray()[this.currentFocus].nativeElement.classList.remove('bg-lumin');
    }

    // Update current focus
    this.currentFocus += direction;
    this.currentFocus = Math.max(0, Math.min(this.currentFocus, this.rows.length - 1));

    const currentRowData = this.data.rows[this.currentFocus];
    if (currentRowData) {
      if(this.id === 'inventoryTable' || this.id === 'historyTable')
        this.saveEmit('Attribute', currentRowData[0].value);
    }

    // Apply focus to new row
    this.setFocusOnCurrentRow();
    /*const newRow = this.rows.toArray()[this.currentFocus];

    if (newRow) {
      newRow.nativeElement.classList.add('bg-lumin');
      newRow.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      // Set focus explicitly on the new row
      newRow.nativeElement.focus();
    }*/
  }

  setFocusOnCurrentRow() {
    const newRow = this.rows.toArray()[this.currentFocus];
    if (newRow) {
      newRow.nativeElement.classList.add('bg-lumin');

      // Scroll into view
      newRow.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      // Set focus explicitly on the new row
      newRow.nativeElement.focus();
    }
  }

  handleKeyDown(event: KeyboardEvent) {
   // console.log("event => ", event);
    if (event.key === 'a' && (event.metaKey || event.ctrlKey)) {
     // console.log("entramos");
        event.preventDefault();
        const input = event.target as HTMLInputElement;
        //console.log("input => ", input);
        input.select();
    }
}



  checkAll() {

    const checkboxes_interno = this.el.nativeElement.querySelectorAll('.checkboxrow');
   // console.log("checkboxes => ", checkboxes_interno);

// Convert the NodeList to an array and assert the type to Element[]
const checkboxesArray = Array.from(checkboxes_interno) as Element[];

// Filter the array to keep only the checkboxes where 'data-selected' is 'true'
const selectedCheckboxes = checkboxesArray.filter(checkbox => {
    return checkbox.getAttribute('data-selected') === 'true';
});


if(selectedCheckboxes.length == 0)
  return false;
else
  return true;
    
   /* se comenta funcion por que no cumple con requisitos de perfomance
    for (let row of this.data.rows) {
      let i = 0;
      for (let cell of row) {
       
        if (cell.getType() === 'checkbox') {
          if (!this.isCheck(cell.value)) {


            return false;
          }
          break;
        }
      }
    }
    return true;*/
  }


  changeShowing(){
    
    this._userService.setpagelimit(this.token, this.perPage, this.dbname).subscribe((r) => {
     
    });
  }
 

   markAllCheckboxesChecked() {
   // console.log("markAllCheckboxesChecked fired");
    this.checkboxes.forEach(checkbox => {
      //console.log("checkbox => ", checkbox);
      checkbox.checked = true;
      const nativeElement = checkbox._elementRef.nativeElement;
      const dataAttribute = nativeElement.getAttribute('data-attr');

     // $("#"+checkbox.id).addClass("classchekeado");
     
    
      //console.log("dataAttribute => ", dataAttribute);
      
    });

    /* var messages = document.querySelectorAll(".mdc-checkbox__native-control");
    for (var i = 0; i < messages.length; i++) {
        console.log("messages[i] =>", messages[i]);

        messages[i].classList.add("checked");
        
    }*/
    //this.cdr.markForCheck();

}

fieldsChange(values:any):void {
  //console.log(values.currentTarget.checked);
}


unSelectAll() {

    let flat = true;
    //if(this.bulk.length > 0)
     // flat = true;

   // console.log("flat => ", flat);

      const checkboxes_interno = this.el.nativeElement.querySelectorAll('.checkboxrow');
    //console.log("checkboxes => ", checkboxes_interno);

// Convert the NodeList to an array and assert the type to Element[]
const checkboxesArray = Array.from(checkboxes_interno) as Element[];

// Filter the array to keep only the checkboxes where 'data-selected' is 'true'
const selectedCheckboxes = checkboxesArray.filter(checkbox => {
    return checkbox.getAttribute('data-selected') === 'true';
});


    checkboxes_interno.forEach(checkbox => { 
      //console.log("checkbox => ", checkbox);
       // checkbox.checked = true; // Set the checkbox as checked

        const dataAttribute = checkbox.getAttribute('data-attr');

    let dataSelected = checkbox.getAttribute('data-selected');

    let newDataSelected = dataSelected === "true" ? "false" : "true";

    if(flat)
      newDataSelected = "false";
    else
       newDataSelected = "true";

    // console.log("newDataSelected => ", newDataSelected);

        checkbox.setAttribute('data-selected', newDataSelected);


  

   // if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-check-square")){
    if(newDataSelected == 'false'){
      //console.log("has fa-check-square");
      
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-check-square");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-square-o");
   //  } else if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-square-o")){
 } else if(newDataSelected == 'true'){
        // console.log("has fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-check-square");
     }


     let value = dataAttribute.toString();

if(flat){
  for ( let i = 0; i < this.bulk.length; i++) {
      if (this.bulk[i] === value) {
        this.bulk.splice(i,1); 

        this.changeBulk.emit({ check: false, value });
        this.bulkListChange.emit(this.bulk);
        return;
      }
    }
} else {
  this.bulk.push(value.toString());
    this.changeBulk.emit({ check: true, value });
    this.bulkListChange.emit(this.bulk);
}
     

    


    });

    return false;
/*
    let flat = false;
    if(this.bulk.length > 0)
      flat = true;
    this.seleccionado.emit(flat);

    return true;
    console.log("selectAll is fired");
    this.ocultar = true;
   
    console.log("this.bulk.length => ", this.bulk.length);
    console.log("this.bulk => ", this.bulk);
     flat = false;
    if(this.bulk.length > 0)
       flat = this.checkAll();
    
      
    console.log("this.data.rows => ", this.data.rows);
    console.log("flat => ", flat);
   
    for (let row of this.data.rows) {
      let i = 0;
      for (let cell of row) {
        if (cell.getType() === 'checkbox') {
          if (flat) {
       
            if (this.isCheck(cell.value)) {
              this.check(cell.value);

            }
          } else {
            if (!this.isCheck(cell.value)) {
              this.check(cell.value);
            }
          }
          break;
        }
      }
    }

  */
    
  // const columns_dt = $('#' + this.id).DataTable().fnClearTable();
  // const columns_dt2 = $('#' + this.id).DataTable().destroy();


 
   // $('#' + this.id).DataTable().ajax.reload();

    //$('#' + this.id).DataTable().order([0, 'asc']).draw();

   
 //this.ngAfterViewInit();

   // let table = $('#' + this.id).DataTable(this.json_data_table);

   //console.log("columns_dt => ", columns_dt);
  // console.log("columns_dt2 => ", columns_dt2);

 // console.log("table => ", table);
  }




  selectAll() {

    let flat = true;
    //if(this.bulk.length > 0)
     // flat = true;

   // console.log("flat => ", flat);

      const checkboxes_interno = this.el.nativeElement.querySelectorAll('.checkboxrow');
    //console.log("checkboxes => ", checkboxes_interno);

// Convert the NodeList to an array and assert the type to Element[]
const checkboxesArray = Array.from(checkboxes_interno) as Element[];

// Filter the array to keep only the checkboxes where 'data-selected' is 'true'
const selectedCheckboxes = checkboxesArray.filter(checkbox => {
    return checkbox.getAttribute('data-selected') === 'true';
});

//console.log(selectedCheckboxes); 
if(selectedCheckboxes.length == 0)
  flat = false;


    checkboxes_interno.forEach(checkbox => { 
      //console.log("checkbox => ", checkbox);
       // checkbox.checked = true; // Set the checkbox as checked

        const dataAttribute = checkbox.getAttribute('data-attr');

    let dataSelected = checkbox.getAttribute('data-selected');

    let newDataSelected = dataSelected === "true" ? "false" : "true";

    if(flat)
      newDataSelected = "false";
    else
       newDataSelected = "true";

    // console.log("newDataSelected => ", newDataSelected);

        checkbox.setAttribute('data-selected', newDataSelected);


  

   // if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-check-square")){
    if(newDataSelected == 'false'){
      //console.log("has fa-check-square");
      
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-check-square");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-square-o");
   //  } else if($('*[data-interno="'+dataAttribute+'"]').hasClass("fa-square-o")){
 } else if(newDataSelected == 'true'){
        // console.log("has fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').removeClass("fa-square-o");
        $('*[data-interno="'+dataAttribute+'"]').addClass("fa-check-square");
     }


     let value = dataAttribute.toString();

if(flat){
  for ( let i = 0; i < this.bulk.length; i++) {
      if (this.bulk[i] === value) {
        this.bulk.splice(i,1); 

        this.changeBulk.emit({ check: false, value });
        this.bulkListChange.emit(this.bulk);
        return;
      }
    }
} else {
  this.bulk.push(value.toString());
    this.changeBulk.emit({ check: true, value });
    this.bulkListChange.emit(this.bulk);
}
     

    


    });

    return false;
/*
    let flat = false;
    if(this.bulk.length > 0)
      flat = true;
    this.seleccionado.emit(flat);

    return true;
    console.log("selectAll is fired");
    this.ocultar = true;
   
    console.log("this.bulk.length => ", this.bulk.length);
    console.log("this.bulk => ", this.bulk);
     flat = false;
    if(this.bulk.length > 0)
       flat = this.checkAll();
    
      
    console.log("this.data.rows => ", this.data.rows);
    console.log("flat => ", flat);
   
    for (let row of this.data.rows) {
      let i = 0;
      for (let cell of row) {
        if (cell.getType() === 'checkbox') {
          if (flat) {
       
            if (this.isCheck(cell.value)) {
              this.check(cell.value);

            }
          } else {
            if (!this.isCheck(cell.value)) {
              this.check(cell.value);
            }
          }
          break;
        }
      }
    }

  */
    
  // const columns_dt = $('#' + this.id).DataTable().fnClearTable();
  // const columns_dt2 = $('#' + this.id).DataTable().destroy();


 
   // $('#' + this.id).DataTable().ajax.reload();

    //$('#' + this.id).DataTable().order([0, 'asc']).draw();

   
 //this.ngAfterViewInit();

   // let table = $('#' + this.id).DataTable(this.json_data_table);

   //console.log("columns_dt => ", columns_dt);
  // console.log("columns_dt2 => ", columns_dt2);

 // console.log("table => ", table);
  }



  check(param) {
    //ya no se usa esta funcion, usamos el listener
    return false;
    /*
    //checkbox.setAttribute('data-selected', newDataSelected);
    let value = param.value.toString();
    for ( let i = 0; i < this.bulk.length; i++) {
      if (this.bulk[i] === value) {
        this.bulk.splice(i,1); 
       // console.log("check encontrado!!!");
        this.changeBulk.emit({ check: false, value });
        return;
      }
    }
    //console.log("check NO encontrado!!!");
    this.bulk.push(value.toString());
    this.changeBulk.emit({ check: true, value });
    return false;*/
  }

   isCheck(value) {

    value = value.toString();
     //se comenta esta funcion  no es optima
   /* for ( let i = 0; i < this.bulk.length; i++) {
      if(this.bulk[i].localeCompare(value)){
      //if (this.bulk[i] === value) {
        return true;
      }
    }*/

   /* let valor = false;

   valor =  if(this.bulk.indexOf(value) !== -1)  
{  
  console.log("regresamos TRUE");
       return true;
} else {
   console.log("regresamos false");
  return false;
}   
*/

    const valor = this.bulk.includes(value);
  

    return valor;

    
  }





  cleanBulk() {
    console.log("cleanBulk fired up!");
    this.selectAll();
    //while (this.bulk.length) {
      //this.check(this.bulk[0]);
    //}
  }

  clickfilter() {
    //console.log('cliqueado');
  }

  onRightClick(event: MouseEvent, column: any, index: number): boolean {
    event.preventDefault();
    this.rightClickAction.emit({ columnName: column, columnIndex: index });
    return false;
  }
  

  changetypefilter(i, type) {
    if (type === 'nofilter') {
      this.columnfilters[i].type = '';
    } else {
      this.columnfilters[i].type = type;
    }

    this.goToPage(1);
  }

}